export default "__VITE_ASSET__BdNL73nC__"